import { render, staticRenderFns } from "./tab-3-history.vue?vue&type=template&id=ce6c396e&scoped=true&lang=pug&"
import script from "./tab-3-history.vue?vue&type=script&lang=js&"
export * from "./tab-3-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6c396e",
  null
  
)

export default component.exports